import { createFileRoute, Outlet } from '@tanstack/react-router';

import {
  requireActiveOrganisation,
  requirePermission,
  requireTwoFactorEnrolment,
} from '@/app/guards';
import { DocsNotFoundPage, DocsShell } from '@/features/docs';

/** Outside `_active` (no AdminShell), so it repeats that layout's two guards. */
export const Route = createFileRoute('/_authed/docs')({
  beforeLoad: ({ context, location }) => {
    requireActiveOrganisation(context.me);
    requireTwoFactorEnrolment(context.me, location);
    requirePermission(context.me, 'docs.read');
  },
  component: () => (
    <DocsShell>
      <Outlet />
    </DocsShell>
  ),
  notFoundComponent: DocsNotFoundPage,
});
